export const applicationDomain = {
  msging: 'postmaster@msging.net',
  desk: 'postmaster@desk.msging.net',
  aiPlatform: 'postmaster@aiplatform.msging.net',
};
